module.exports = __webpack_public_path__ + "static/media/cliente-moinho-sertao-forte.1c59658a.webp";